import { PatientInformation } from "~/patients/utils/types";
import { api } from "../axios";

export const getCurrentPatient = async () => {
  const res = await api.get<PatientInformation>("/v1/patients/current");
  return res.data;
};
